export const content = {
    prague: {
        title: 'contact.prague.map.title',
        description: 'contact.prague.map.description',
    },
    berlin: {
        title: 'contact.berlin.map.title',
        subtitles: [
            {
                id: 1,
                message: 'contact.berlin.map.subtitle1',
            },
            {
                id: 2,
                message: 'contact.berlin.map.subtitle2',
            },
        ],
        address: [
            {
                id: 1,
                message: 'contact.berlin.map.address1',
            },
            {
                id: 2,
                message: 'contact.berlin.map.address2',
            },
            {
                id: 3,
                message: 'contact.berlin.map.address3',
            },
        ],
        driveryImageAlt: 'contact.berlin.map.driveryImageAlt',
    },
};
